import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';

// services
import { OrdersService } from '../services/orders.service';
import { ShopsService } from './../services/shops.service';

// Interface
import { OrderDetails } from '../interfaces/order-details';


class Utils {
    static isColorOption(_option) {
        return _option === "color" || _option === "insideMat" || _option === "outsideMat";
    }
}


@Component({
    selector: 'app-order-details',
    templateUrl: './order-details.component.html',
    styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit {
    @Input() public order;
    @Input() public network;
    @Input() public dataPDF;
    @Input() public role;
    @BlockUI() blockUI: NgBlockUI;

    orderDetails: OrderDetails;
    productOption: any;
    productDetailSet;
    productDeta
    priceProviderTotal;
    productDetail: any;
    orderReady: boolean = false;
    showDates: boolean;
    isHidden: boolean = false;
    FS: string;
    S3_SCREENSHOT_PUBLIC_URL: string;


    activePdfTemplate: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private ordersService: OrdersService,
        private toastrService: ToastrService,
        private shopsService: ShopsService,
    ) { }

    ngOnInit(): void {
        this.productDetailSet = [];
        this.priceProviderTotal = 0;
        this.getOrder();
        this.FS = environment.fileServer;
        this.S3_SCREENSHOT_PUBLIC_URL = environment.S3_SCREENSHOT_PUBLIC_URL;
    }

    private displayEstimateDates(): boolean {
        return this.orderDetails.estimateStart != "" || this.orderDetails.estimateEnd != ""
    }

    private getOrder(): void {

        this.blockUI.start('Loading');

        this.ordersService.getOrderDetails(this.order.id, this.network).subscribe(
            async (res) => {
                if (res.success) {
                    this.orderDetails = res.data;
                    if (!this.dataPDF.userIsShop) {
                        this.getShopDetailById();
                    }

                    this.showDates = this.displayEstimateDates();

                    this.productOption = {};

                    for (let [index, product] of this.orderDetails.products.entries()) {
                        let parseOptions;
                        try {
                            parseOptions = JSON.parse(product.options.config);
                        } catch {
                            parseOptions = product.options;
                        }
                        let newOption = await this.parseOption(parseOptions, product.product_id, product.subcategory_id);

                        this.productOption[product.id] = newOption;

                        // let data = {
                        // 	context: {
                        // 		app: "WEB",
                        // 		network: this.network
                        // 	},
                        // 	productOpt: this.orderDetails.products[index].options
                        // }

                        // Object.assign(data.productOpt, {id: this.orderDetails.products[index].product_id});
                        // Object.assign(data.productOpt, {idCategory: this.productDetailSet[index].idCategory});
                        // Object.assign(data.productOpt, {idSubCategory: this.orderDetails.products[index].subcategory_id});

                        // for (let [key, value] of Object.entries(data.productOpt)) {

                        // 	if (data.productOpt[key] === 'true') {
                        // 		data.productOpt[key] = true;

                        // 	} else if (data.productOpt[key] === 'false') {
                        // 		data.productOpt[key] = false;
                        // 	}
                        // }

                        // this.getProductPrice(data);
                        //@ts-ignore
                        this.priceProviderTotal += (product.price / this.getCoefFromSubCat(product));
                    }

                    this.orderReady = true;
                    this.blockUI.stop();

                } else {
                    this.blockUI.stop();

                    if (res.errorSet.includes('INVALID_PARAMS')) {
                        this.toastrService.error('Les paramètres sont invalides');
                    } else if (res.errorSet.includes('ERROR_SERVER')) {
                        this.toastrService.error('Une erreur serveur est survenue');
                    } else {
                        this.toastrService.error('Une erreur s\'est produite');
                    }
                    this.activeModal.close();
                }
            },
            (error) => {
                this.blockUI.stop();
                // console.error(error);
                this.toastrService.error('Une erreur s\'est produite');
            }
        );
    }

    public getCoefFromSubCat(product: any) {
        const type_pose = product.options.type_pose;
        const productDetail = this.productDetailSet.find((p: any) => p.id === product.product_id);

        let coef = 0;
        switch (type_pose) {
            case "Reno":
            case "Rénovation":
                coef = this.network === "MDM" ? parseFloat(productDetail.coefMDMreno) : parseFloat(productDetail.coefSMreno);
                break;
            default:
                coef = this.network === "MDM" ? parseFloat(productDetail.coefMDMneuf) : parseFloat(productDetail.coefSMneuf);
        }

        return coef;
    }

    public getCommissionPriceDetails() {

        const commissionPercent = 0.17;
        const commissionHTCents = parseInt(((this.orderDetails?.priceDetail?.totalHT || 0) * commissionPercent * 100).toFixed(0));
        const commissionTVACents = Math.round(commissionHTCents * 0.2);
        const commissionTTC = commissionHTCents + commissionTVACents;

        return {
            HT: commissionHTCents / 100,
            TTC: commissionTTC / 100,
            TVA: commissionTVACents / 100
        }
    }


    public getTotalPriceSold(products) {
        var priceSold = 0;
        for (var product of products) {
            //@ts-ignore
            priceSold += (product.price / this.getCoefFromSubCat(product));
        }

        return priceSold.toFixed(2);
    }

    // private getProductPrice(data: object): void {

    // 	this.blockUI.start('Loading');

    // 	this.ordersService.getProductPrice(data).subscribe(
    // 		(res) => {
    // 			if (res.success) {

    // 				if(this.renovCat.includes(res.data.idSubCategory)) {
    // 					Object.assign(res.data, {coef: 1.75});
    // 				} else {
    // 					Object.assign(res.data, {coef: 1.4});
    // 				}

    // 				let price = {
    // 					price: (res.data.totalHTPrice / res.data.coef ).toFixed(2),
    // 					totalHTPrice: res.data.totalHTPrice,
    // 					totalTTCPrice: res.data.totalTTCPrice,
    // 					tva: res.data.tva
    // 				}

    // 				this.totalHTPrice = parseFloat((this.totalHTPrice + res.data.totalHTPrice).toFixed(2));
    // 				this.totalTVA = parseFloat((this.totalTVA + res.data.tva).toFixed(2));
    // 				this.totalTTCPrice = parseFloat((this.totalTTCPrice + res.data.totalTTCPrice).toFixed(2));

    // 				this.productPriceSet.push(price);
    // 				this.blockUI.stop();

    // 			} else {
    // 				this.blockUI.stop();
    // 				this.toastrService.error('Une erreur serveur est survenue');
    // 			}
    // 		},
    // 		(error) => {
    // 			this.blockUI.stop();
    // 			this.toastrService.error('Une erreur s\'est produite');
    // 		}
    // 	)
    // }

    private isOptionEnabled(option, disabledKeys, idSubCategory) {
        if (disabledKeys && Array.isArray(disabledKeys)) {
            const keyInfo = disabledKeys.find(info => info.name === option);

            if (keyInfo) {
                // If idSubCategoryHidden is provided and matches the given idSubCategory, hide the option
                if (keyInfo.idSubCategoryHidden === idSubCategory) {
                    return false;
                }

                // If idSubCategoryHidden is not provided, hide the option for all subcategories
                if (keyInfo.idSubCategoryHidden === undefined) {
                    return false;
                }
            }
        }
        return true;
    }

    private getShopDetailById(): void {
        this.blockUI.start('Loading')
        this.shopsService.getShopDetailById(this.orderDetails.shopId).subscribe(
            (res) => {

                if (res.success) {
                    this.dataPDF = {
                        shop: {
                            name: res.data.shopName,
                            address: res.data.shopAddress,
                            cp: res.data.shopPostalCode,
                            city: res.data.shopCity,
                            phone: res.data.telephoneNumber,
                            email: res.data.email
                        },
                        userIsShop: true
                    }

                    this.blockUI.stop();

                } else {
                    this.blockUI.stop();
                    if (res.errorSet.includes('ERROR_SERVER')) {
                        this.toastrService.error('Une erreur serveur est survenue');
                    }
                }
            },
            (error) => {
                this.blockUI.stop();
                this.toastrService.error('Une erreur s\'est produite');
            }
        );
    }

    private async parseOption(options, product_id, idSubCategory): Promise<any> {
        try {
            this.productDetail = {};
    
            const [result, opt] = await Promise.all([
                this.ordersService.getProductDetails(product_id, this.network).toPromise(),
                this.ordersService.optionsLabels({config: options, idSubCategory: idSubCategory}).toPromise()
            ]);
    
            if (result.success) {
                this.productDetail = result.data;
                this.productDetailSet.push(this.productDetail)
    
                // Throw error if product detail is empty
                if (Object.keys(this.productDetail).length === 0) {
                    throw 'Could not retrieve product data';
                }
            } else {
                throw result.errorSet[0];
            }

            return opt.data.result;
        } catch (err) {
            console.error(err)
            this.toastrService.error("Une erreur est survenue.");
        }
    }


    generatePdf(isShopFee) {

        this.blockUI.start('Création du pdf');

        this.activePdfTemplate = true;
        if (isShopFee) {
            this.isHidden = true;
        } else {
            this.isHidden = false;
        }

        setTimeout(() => {

            let data = document.getElementById('PDF');
            // @page { size: auto;  margin: 0mm; }

            var printWindow = window.open('', '', 'height=600,width=1000');
            printWindow.document.write(`
				<style>
					.break {
						break-inside: avoid-page;
						overflow:initial !important
					}

					html {
						width: 100%;
						height: 100%;
						margin: 0;
						padding: 0;
						font-family: system-ui;
					}

					body {
						margin: 0;
						-webkit-print-color-adjust: exact !important;
					}

					#MDM .colorThead {
						background-color: #4A4A4A;
						color: white;
					}

					#SM .colorThead {
						background-color: #F4F4F4;
						color: #1D1D1D;
					}

					#MDM .colorBorder {
						border-color: #EC008C;
					}

					#SM .colorBorder {
						border-color: #F6AE33;
					}

					/* HEADER */

					#MDM .SM {
						display: none !important;
					}

					#SM .MDM {
						display: none !important;
					}

					header {
						display: flex;
						justify-content: space-between;
					}

					.logo {
						width: 300px;
						margin-bottom: 40px;
					}

					.shopInfo p:nth-child(4) {
						margin-top: 25px;
					}

					.shopInfo p:nth-child(5),
					.shopInfo p:nth-child(4) {
						font-weight: 600;
						font-size: 14px;
					}

					.shopInfo p {
						margin: 5px 0;
					}

					.right-header {
						display: flex;
						flex-direction: column;
						align-content: flex-end;
						align-items: flex-end;
					}

					.order {
						width: fit-content;
						border: 2px solid;
						border-radius: 10px;
						padding: 15px 10px;
						margin-bottom: 60px;
					}

					.order .numOrder {
						font-weight: 600;
						font-size: 16px;
						text-align: center;
						margin: 0 0 10px 0;
					}

					.order p {
						margin: 8px 0;
						font-size: 14px;
					}


					.clientInfo {
						text-align: right;
					}

					.clientInfo p {
						margin: 5px 0;
					}

					.deliveryInfo {
						margin: 50px 0;
					}

					.deliveryInfo p {
						margin: 5px 0;
						font-size: 14px;
					}

					/* END HEADER */

					table {
						margin: 0;
						border: 1px solid #AEA6A6;
						background-color: #FFFFFF;
						text-align: center;
						border-collapse: collapse;
                        width: 100%;
					}

					.product-options {
						min-height: 1000px
					}
                    
                    table thead th, table tbody td {
                        vertical-align: middle;
                    }

                    table tbody tr {
                        border-bottom: none;
                    }

                    table thead th, table td {
                        border-left: 1px solid #AEA6A6;
                        padding: 10px 5px;
                        white-space: nowrap;
                    }

                    table thead th {
                        border-bottom: 1px solid #AEA6A6;
                    }

					table.blueTable img {
						width: 70px;
					}

					table.blueTable td.info {
						text-align: left;
					}

					.product-description p:first-child {
						font-size: 16px;
						margin: 0;
					}

					.product-description p:last-child {
						margin: 10px 0 0;
					}

					.product-options {
						margin: 20px 0 10px;
					}

					.product-options p {
						margin: 10px 0 0;
					}

					.product-options p strong {
						text-transform: uppercase;
					}

					.td-number {
						margin: 40px 15px 0;
					}

					.payment {
						display: flex;
						margin: 50px 0 0;
					}

					.paymentInfo {
						flex: 1;
						border: 2px solid #AEA6A6;
						border-radius: 10px;
						padding: 15px;
						margin-right: 20px;
					}

					.paymentInfo p:first-child {
						margin: 0;
						margin-bottom: 20px;
					}

					.paymentInfo p {
						margin: 0px;
						line-height: 25px;
					}

					.priceInfo {
						border: 2px solid;
						border-radius: 10px;
						padding: 15px;
						display: flex;
						align-items: flex-end;
						flex-direction: column;
					}

					.priceInfo div {
						display: flex;
						justify-content: space-between;
						width: 100%;
					}

					.priceInfo div:nth-child(1),
					.priceInfo div:nth-child(2) {
						border-bottom: 2px solid #AEA6A6;
					}

					.priceInfo div p {
						margin: 10px;
					}

					.priceInfo .price{
						margin-left: 60px;
					}

					.signInfo{
						border: 2px solid #AEA6A6;
						border-radius: 10px;
						margin-top: 15px;
						display: flex;
					}

					.signInfo .bdc-ct {
						padding: 15px;
						border-right: 2px solid #AEA6A6;
					}

					.signInfo .bdc-ct p {
						margin: 0;
						white-space: nowrap;
					}

					.signInfo .info-ct {
						display: flex;
						flex-direction: row;
						flex: 1;
						padding: 0 15px;
						align-items: center;
					}

					.signInfo .info-ct p {
						margin-right: 100px;
						white-space: nowrap;
					}

					.credit {
						font-size: 10px;
						color: #4A4A4A;
						text-align: center;
						margin-top: 30px;
					}
				</style>

				<script>
					window.onload = function () {
						window.print();
					}
				</script>
			`);
            printWindow.document.write(data.innerHTML);
            printWindow.document.close();

            this.blockUI.stop();
        }, 1)
    }
}